export const initialState = (): Record<string, unknown> => ({});
